import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const generateTemplateApi = async (body = {}, authHeaders = {}) => {
  try {
    const res = await apiCallPost(apiPaths.whatsappTemplate, body, authHeaders);

    if (res) {
      const bodyError = res.error || (res.payload && res.payload.error) || null;
      const statusField = (res.status && typeof res.status === 'string') ? res.status.toUpperCase() : null;

      if (bodyError || statusField === 'FAILED') {
        const errMsg = (bodyError && (bodyError.error || bodyError.message)) || res.message || 'Failed to generate template';
        return { data: res, status: false, errMsg };
      }

      return { data: res, status: true };
    }

    return { data: {}, status: false, errMsg: 'Failed to generate template' };
  } catch (err) {
    const errMsg = err.baseError?.error?.error || err.baseError?.error?.message || err.baseError?.message || err.message || 'Failed to generate template';
    return { status: false, errMsg };
  }
};
